import Home from "../home/Home";
import useAuth from "../../hooks/useAuth";
import { useEffect, useState } from "react";
import Select from 'react-select';
import Button from "../../components/Button";
import InfoButton from "../../components/InfoButton";

const Entry = () => {
    const {auth, setAuth} = useAuth();
    const [page, setPage] = useState(1);
    const [l1Options, setL1Options] = useState([]);

    const [username, setUsername] = useState("");
    const [usernameError, setUsernameError] = useState(null);
    const [pw, setPw] = useState("");
    const [pwError, setPwError] = useState(null);

    const [regUsername, setRegName] = useState("");
    const [regUsernameError, setRegUsernameError] = useState(null);
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(null);
    const [regPw, setRegPw] = useState("");
    const [regPwError, setRegPwError] = useState(null);
    const [confirmPw, setConfirmPw] = useState("");
    const [confirmPwError, setConfirmPwError] = useState(null);
    const [role, setRole] = useState("USER");

    const [l2, setL2] = useState("Catalan (Central)");
    const [l1, setL1] = useState("Other");

    const [firstName, setFirstName] = useState("");
    const [firstNameError, setFirstNameError] = useState(null);
    const [lastName, setLastName] = useState("");
    const [lastNameError, setLastNameError] = useState(null);
    const [birth, setBirth] = useState("");
    const [birthError, setBirthError] = useState(null);
    const [gender, setGender] = useState(null);
    const [genderError, setGenderError] = useState(null);
    const [otherLangs, setLangs] = useState([]);
    const [livesInL2, setLives] = useState(false);
    const [arrival, setArrival] = useState("");
    const [arrivalError, setArrivalError] = useState(null);
    const [l2Start, setL2Start] = useState("");
    const [l2StartError, setL2StartError] = useState(null);
    const [freq, setFreq] = useState("every day");
    const [freqError, setFreqError] = useState(null);
    const [l2Location, setLocation] = useState("everywhere");
    const [l2LocationError, setLocationError] = useState(null);
    const [showConsent, setShowConsent] = useState(false);
    const [consent, setConsent] = useState(false);

    const checkToken = async () => {
        const token = localStorage.getItem("token");
        if (token && !auth?.email) {
            const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/me`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
            });
            if (response.ok) {
                let userData = await response.json();
                userData.token = token;
                setAuth(userData);
            }
        }
    }

    const getUserData = async (token) => {
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/me`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });
        if (response.ok) {
            let userData = await response.json();
            userData.token = token;
            setAuth(userData);
            localStorage.setItem("token", token);
        }
    };
    
    const Login = async () => {
        clearErrors();

        let foundErrors = false;

        if (username === "") {
            setUsernameError("Required");
            foundErrors = true;
        }
        if (pw === "") {
            setPwError("Required");
            foundErrors = true;
        }
        if (!foundErrors) {
            const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: username,
                    password: pw
                })
            });
            if (response.ok) {
                const token = await response.json();
                await getUserData(token.token);
            } else if (response.status === 401) {
                setPwError("Wrong username or password.");
            }
        }
        clearInput();
    }

    const getRegNameError = async (newName) => {
        if (newName === "") {
            return "Username is required.";
        }
        for (let c of [" ", "/"]) {
            if (newName.includes(c)) {
                return `Username cannot include \"${c}\".`;
            }
        }
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/name-exists/${newName}`);
        if (response.ok) {
            const json = await response.json();
            if (json.exists) {
                return "This username is taken.";
            }
        }
        return null;
    }

    const changeName = async (newName) => {
        setRegName(newName);
        setRegUsernameError(await getRegNameError(newName));
    }

    const getEmailError = async (newEmail) => {
        if (newEmail === "") {
            return "Email is required.";
        }
        if (!newEmail.includes("@")) {
            return "Email must be in the format of 'email@email.com'.";
        }
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/email-exists/${newEmail}`);
        if (response.ok) {
            const json = await response.json();
            if (json.exists) {
                return "This email is taken.";
            }
        }
        return null;
    }

    const changeEmail = async (newEmail) => {
        setEmail(newEmail);
        setEmailError(await getEmailError(newEmail));
    }

    const hasUpperCase = (s) => {
        return s !== s.toLowerCase();
    }

    const hasLowerCase = (s) => {
        return s !== s.toUpperCase();
    }

    const hasDigits = (s) => {
        return /\d/.test(s);
    }

    const pw_min_len = 8;
    const getPwError = (newPw) => {
        if (newPw === "") {
            return "Password is requried.";
        }
        if (newPw.length < pw_min_len) {
            return `Password must be at least ${pw_min_len} characters.`;
        }
        if (!hasUpperCase(newPw)) {
            return "Password must include uppercase characters.";
        }
        if (!hasLowerCase(newPw)) {
            return "Password must include lowercase characters.";
        }
        if (!hasDigits(newPw)) {
            return "Password must include digits.";
        }
        return null;
    }

    const changePw = (newPw) => {
        setRegPw(newPw);
        setRegPwError(getPwError(newPw));
    }

    const getConfirmPwError = (newPw) => {
        if (newPw === "") {
            return "Password must be repeated.";
        }
        if (newPw !== regPw) {
            return "Passwords do not match.";
        }
        return null;
    }

    const changeConfirmPw = (newPw) => {
        setConfirmPw(newPw);
        setConfirmPwError(getConfirmPwError(newPw));
    }

    const getFirstNameError = (newName) => {
        if (newName === "") {
            return "First name is required.";
        }
        return null;
    }

    const changeFirstName = (newName) => {
        setFirstName(newName);
        setFirstNameError(getFirstNameError(newName));
    }

    const getLastNameError = (newName) => {
        if (newName === "") {
            return "Last name is required.";
        }
        return null;
    }
        
    const changeLastName = (newName) => {
        setLastName(newName);
        setLastNameError(getLastNameError(newName));
    }

    const GuestProceed = (event) => {
        event.preventDefault();
        setRegName("guest");
        setEmail("guest");
        setRole("USER");
        setPage(2);
    }

    const Page2Submit = () => {
        if (regUsername === "guest") {
            setAuth({'email': 'guest', 'username': 'guest'});
            setPage(1);
        } else {
            setPage(3);
        }
    }

    const toggleConsent = () => {
        setConsent(!consent);
        setShowConsent(false);
    }

    const toggleShowConsent = () => {
        setShowConsent(!showConsent);
    }

    const register = async () => {
        clearErrors();

        let foundErrors = false;

        if (regUsername === "") {
            setRegUsernameError("Required");
            setPage(1);
            foundErrors = true;
        }
        if (email === "") {
            setPage(1);
            setEmailError("Required");
            foundErrors = true;
        }
        if (regPw === "") {
            setPage(1);
            setRegPwError("Required");
            foundErrors = true;
        }
        if (confirmPw === "") {
            setPage(1);
            setConfirmPwError("Required");
            foundErrors = true;
        }
        if (confirmPw !== regPw) {
            setPage(1);
            setConfirmPwError("Does not match");
            foundErrors = true;
        }
        if (firstName === "") {
            setFirstNameError("Required");
            foundErrors = true;
        }
        if (lastName === "") {
            setLastNameError("Required");
            foundErrors = true;
        }
        if (birth === "") {
            setBirthError("Required");
            foundErrors = true;
        }
        if (gender === null) {
            setGenderError("Required");
            foundErrors = true;
        }
        if (livesInL2 && arrival === "") {
            setArrivalError("Required");
            foundErrors = true;
        }
        if (l2Start === "") {
            setL2StartError("Required");
            foundErrors = true;
        }
        if (freq === "") {
            setFreqError("Required");
            foundErrors = true;
        }
        if (l2Location === "") {
            setLocationError("Required");
            foundErrors = true;
        }
        if (!foundErrors) {
            const body = {
                username: regUsername,
                email: email,
                password: regPw,
                role: role,
                l1: l1,
                l2: l2,
                first_name: firstName,
                last_name: lastName,
                birth_date: birth,
                gender: gender,
                other_langs: otherLangs,
                l2_when: l2Start,
                l2_arrival: arrival === "" ? null : arrival,
                // Commented out because it was previously an int
                //l2_per_month: freq,
                l2_location: l2Location,
                l2_frequency: freq
            }
            const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/register`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            if (response.ok) {
                const loginResponse = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/login`, {
                    method: "POST",
                    headers: {
                    "Content-Type": "application/json"
                    },
                    body: JSON.stringify({email: email, password: regPw})
                });
                const token = await loginResponse.json();
                getUserData(token["token"]);
            } else if (response.status === 409) {
                setPage(1);
                const respJson = await response.json();
                switch(respJson.detail.split(" ")[2]) {
                    case "username": 
                        setRegName("Username already exists");
                        break;
                    case "email":
                        setEmailError("Email already exists");
                        break;
                }
            }
        }
        clearInput();
    }

    const prev = () => {
        setPage(page - 1);
    }

    const completeP1 = async () => {
        let errFound = false;

        for (let xs of [
            [await getRegNameError(regUsername), setRegUsernameError],
            [await getEmailError(email), setEmailError],
            [getPwError(regPw), setRegPwError],
            [getConfirmPwError(confirmPw), setConfirmPwError]
        ]) {
            if (xs[0]) {
                xs[1](xs[0]);
                errFound = true;
            }
        }

        if (!errFound) {
            setPage(2);
        }
    }

    const clearInput = () => {
        setUsername("");
        setPw("");
        setRegName("");
        setEmail("");
        setRegPw("");
        setConfirmPw("");
        setRole("USER");
        setL2("Catalan (Central)");
        setL1("Other");
        setFirstName("");
        setLastName("");
        setBirth("");
        setGender(null);
        setLangs([]);
        setLives(false);
        setArrival("");
        setL2Start("");
        setFreq("every day");
        setLocation("everywhere");
        setConsent(false);
    }

    const clearErrors = () => {
        setUsernameError(null);
        setPwError(null);
        setRegUsernameError(null);
        setEmailError(null);
        setRegPwError(null);
        setConfirmPwError(null);
        setFirstNameError(null);
        setLastNameError(null);
        setBirthError(null);
        setGenderError(null);
        setArrivalError(null);
        setL2StartError(null);
        setFreqError(null);
        setLocationError(null);
    }

    const canClickLogin = () => {
        return username !== "" && pw !== "";
    }

    const canClickNext = () => {
        return regUsername !== "" && email !== "" && regPw !== "" && confirmPw !== "";
    }

    const canClickRegister = () => {
        return firstName !== "" && lastName !== "" && birth !== "" && gender !== null && !(livesInL2 && arrival !== "") && l2Start !== "" && consent;
    }

    const Divider = () => {
        return <hr style={{
            borderTop: "2px solid lightgrey",
            width: "30%"
        }}/>
    };

    const ErrorDiv = ({err}) => {
        if (err) {
            return <div className="text-red-500">
                {err}
            </div>
        }
    }

    const PrevButton = () => {
        return <Button
            text="Prev"
            func={prev}
        />
    }

    const rolesList = [
        { value: 'USER', label: 'User' },
        { value: 'ADMIN', label: 'Admin' },
        { value: 'TEACHER', label: 'Teacher' }
    ];

    const l2Options = [
        {value: "Catalan (Central)", label: "Catalan (Central)"},
        {value: "Spanish (Castilian)", label: "Spanish (Castilian)"},
        {value: "Italian", label: "Italian"},
        {value: "Norwegian", label: "Norwegian"},
        {value: "English", label: "English"}
    ];

    const genders = [
        {value: null, label: "Not specified"},
        {value: "Male", label: "Male"},
        {value: "Female", label: "Female"},
        {value: "Non-binary", label: "Non-binary"}
    ]

    const freqs = [
        {value: "every day", label: "every day"},
        {value: "once a week", label: "at least once a week"},
        {value: "once a month", label: "at least once a month"}
    ]

    const locations = [
        {value: "everywhere", label: "everywhere"},
        {value: "home", label: "at home"},
        {value: "school", label: "at school"},
        {value: "work", label: "at work"},
        {value: "elsewhere", label: "elsewhere"},
        {value: "nowhere", label: "nowhere"}
    ]

    const inputTailwind = "border-2 border-blue-500 rounded";

    useEffect(() => {checkToken()});

    useEffect(() => {
        fetch(`${process.env.REACT_APP_USER_API_URL}/exercises/list_languages`).then(response => response.json()).then(json => {
            let options = [];
            for (const lang of json.result) {
                options.push({label: lang.name, value: lang.name});
            }
            setL1Options(options);
        });
    }, []);

    if (auth?.email) {
        return <div>
            <Home inL1={l1} inL2={l2}/>
        </div>
    }

    return <div>
        <div className="flex flex-col px-10 py-10 gap-y-10 my-5 border-2 border-sky-600 rounded-xl shadow-md mx-auto bg-sky-50"> 
            <p className="mx-auto text-4xl  font-bold text-blue-600">
                Pygmalion:
            </p>
            <p className=" text-xl  mx-auto font-semibold text-blue-400">            
                the prototype for The computer-assisted listening and speaking tutor (CALST)
            </p>
        </div>
        {page === 1 && <div className="flex flex-col items-center">
            <form className="grid grid-cols-2">
            <div>Login:</div>
                <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="text"
                        value={username}
                        placeholder="username or email@email.com"
                        onChange={e => setUsername(e.target.value)}
                    />
                    <ErrorDiv err={usernameError} />
                </div>
                <div />
                <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="password"
                        value={pw}
                        placeholder="your password"
                        onChange={e => setPw(e.target.value)}
                    />
                    <ErrorDiv err={pwError}/>
                </div>
                <div />
                <Button text="Login" func={Login} clickable={canClickLogin()} />
                <div />
            </form>
            <Divider />
            <form className="grid grid-cols-2">
                <div>Create new account:</div>
                <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="text"
                        value={regUsername}
                        placeholder="username"
                        onChange={e => changeName(e.target.value)}
                    />
                    <ErrorDiv err={regUsernameError} />
                </div>
                <div />
                <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="email"
                        value={email}
                        placeholder="email@email.com"
                        onChange={e => changeEmail(e.target.value)}
                    />
                    <ErrorDiv err={emailError} />
                </div>
                <div />
                <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="password"
                        value={regPw}
                        placeholder="select password"
                        onChange={e => changePw(e.target.value)}
                    />
                    <ErrorDiv err={regPwError} />
                </div>
                <div />
                <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="password"
                        value={confirmPw}
                        placeholder="repeat password"
                        onChange={e => changeConfirmPw(e.target.value)}
                    />
                    <ErrorDiv err={confirmPwError} />
                </div>
                <div />
                <Select
                    className={inputTailwind}
                    type="text"
                    options={rolesList}
                    defaultValue={rolesList[0]}
                    onChange={option => setRole(option.value)}
                />
                <div />
                <Button text="Next" func={completeP1} clickable={canClickNext()} />
            </form>
            <Divider />
            <div className="grid grid-cols-2">
                <div className="flex flex-col">
                    <div>Guest login:</div>
                    <small>No data is logged</small>
                </div>
                <Button text="Proceed as guest" func={GuestProceed} />
            </div>
        </div>}
        {page === 2 && <div className="flex flex-col items-center">
            <form className="grid grid-cols-2">
                <div>Language course (L2):</div>
                <Select
                    className={inputTailwind}
                    type="text"
                    options={l2Options}
                    defaultValue={l2Options[0]}
                    onChange={option => setL2(option.value)}
                />
                <div>Native language (L1):</div>
                <Select
                    className={inputTailwind}
                    type="text"
                    options={l1Options}
                    defaultValue={l1Options[0]}
                    onChange={option => setL1(option.value)}
                />
                <PrevButton />
                <Button text="Next" func={Page2Submit} />
            </form>
        </div>}
        {page === 3 && <div className="flex flex-col items-center">
            <form className="grid grid-cols-3">
                <div>First name:</div>
                <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="text"
                        value={firstName}
                        placeholder="your first name"
                        onChange={e => changeFirstName(e.target.value)}
                    />
                    <ErrorDiv err={firstNameError} />
                </div>
                <div />
                <div>Last name:</div>
                <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="text"
                        value={lastName}
                        placeholder="your last name"
                        onChange={e => changeLastName(e.target.value)}
                    />
                    <ErrorDiv err={lastNameError} />
                </div>
                <div />
                <div>Date of birth:</div>
                <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="date"
                        value={birth}
                        placeholder="dd/mm/yyyy"
                        onChange={e => setBirth(e.target.value)}
                    />
                    <ErrorDiv err={birthError} />
                </div>
                <div />
                <div>Gender:</div>
                <div className="flex flex-col">
                    <Select
                        className={inputTailwind}
                        type="text"
                        options={genders}
                        defaultValue={genders[0]}
                        onChange={option => setGender(option.value)}
                    />
                    <ErrorDiv err={genderError} />
                </div>
                <div />
                <div>Other languages:</div>                
                <Select
                    className={inputTailwind}
                    options={l1Options}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    onChange={selected => setLangs(selected.map(option => option.value))}
                />
                <div />
                <div>Do you live in L2 country?:</div>
                <input
                    className={inputTailwind}
                    type="checkbox"
                    onChange={e => setLives(e.target.value)}
                />
                <div />
                {livesInL2 && <div>Arrival in L2 country:</div>}
                {livesInL2 && <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="date"
                        value={arrival}
                        placeholder="dd/mm/yyyy"
                        onChange={e => setArrival(e.target.value)}
                    />
                    <ErrorDiv err={arrivalError} />
                </div>}
                {livesInL2 && <div />}
                <div>Start of L2 learning:</div>
                <div className="flex flex-col">
                    <input
                        className={inputTailwind}
                        type="date"
                        value={l2Start}
                        placeholder="dd/mm/yyyy"
                        onChange={e => setL2Start(e.target.value)}
                    />
                    <ErrorDiv err={l2StartError} />
                </div>
                <div />
                <div>Frequency of L2 use:</div>
                <div className="flex flex-col">
                    <Select
                        className={inputTailwind}
                        type="text"
                        placeholder="every day"
                        options={freqs}
                        defaultValue={freqs[0]}
                        onChange={option => setFreq(option ? option.value : option)}
                    />
                    <ErrorDiv err={freqError} />
                </div>
                <div />
                <div>I use the L2:</div>
                <div className="flex flex-col">
                    <Select
                        className={inputTailwind}
                        type="text"
                        placeholder="everywhere"
                        options={locations}
                        defaultValue={locations[0]}
                        onChange={option => setLocation(option ? option.value : option)}
                    />
                    <ErrorDiv err={l2LocationError} />
                </div>
                <div />
                <div />
                <div className="flex flex-col">
                    <Button text="I consent to the use of my data" func={toggleConsent} />
                    <small>If you do not consent, please log in as guest</small>
                </div>
                <InfoButton func={toggleShowConsent} />
                <div />
                <Button text="Register" func={register} clickable={canClickRegister()} />
                <div />
                <div />
                <PrevButton />
                <div />
            </form>
        </div>}
    </div>
}

export default Entry;
